module.exports = __webpack_public_path__ + "img/invite-image.1ac9c9e5.jpg";